import { Checkbox, FormControl } from '@chakra-ui/react'
import { FC } from 'react'

interface AlcadaCheckboxProps {
  isChecked: boolean
  onChange: (value: boolean) => void
}

// Checkbox com borda visível sobre fundo branco (modais de alçada)
const AlcadaCheckbox: FC<AlcadaCheckboxProps> = ({
  isChecked,
  onChange,
  children
}) => (
  <FormControl mb={4}>
    <Checkbox
      isChecked={isChecked}
      onChange={e => onChange(e.target.checked)}
      colorScheme="green"
      sx={{
        '.chakra-checkbox__control': {
          bg: 'white',
          border: '2px solid',
          borderColor: 'gray.400',
          _hover: { borderColor: 'gray.600' },
          _checked: {
            bg: 'green.600',
            borderColor: 'green.600',
            color: 'white'
          }
        }
      }}
    >
      {children}
    </Checkbox>
  </FormControl>
)

export default AlcadaCheckbox
